import React from 'react';
import { useBedrockRegistration } from 'store';
import { useRouter } from 'next/router';
import { SCREENS } from 'lib/loginFormConstants';
import styles from './styles.module.scss';

/**
 * Render select to display a menu to manually select screen for authentication flow.
 * For QE purposes to bypass API calls to verify inidividual screens.
 * @returns {React.ReactElement|null} The rendered component with select option
 */
const ManualSelect = () => {
  const screen = useBedrockRegistration((state) => state.screen);
  const setScreen = useBedrockRegistration((state) => state.setScreen);

  const {
    query: { MANUAL_SCREEN: shouldShowManualScreen },
  } = useRouter();
  if (shouldShowManualScreen !== 'true') return null;
  /**
   * Manually sets the screen based on the selected value.
   *
   * @param {object} e - The event object.
   */
  const manuallySetScreen = (e) => {
    setScreen(e.target.value);
  };

  return (
    <div className={styles.container}>
      <p>Manually set screen to bypass API calls</p>
      <select onChange={manuallySetScreen} value={screen}>
        {Object.values(SCREENS).map((screenName) => (
          <option key={screenName} value={screenName}>
            {screenName}
          </option>
        ))}
      </select>
    </div>
  );
};

export { ManualSelect };
